import { render, staticRenderFns } from "./t-dialog-confirm.vue?vue&type=template&id=dae92e26&"
import script from "./t-dialog-confirm.vue?vue&type=script&lang=js&"
export * from "./t-dialog-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports